module.exports = __webpack_public_path__ + "static/media/icon_menu.ccfc15e8.svg";